import ErrorNote from "./ErrorNote";
export * from "./ErrorNote";
export default ErrorNote;
